<div
  class="expandable-card-wrapper"
  #cardWrapper
  [class.show-less]="!showAll"
  [class.show-all]="showAll || !isExpandable"
>
  <ng-content></ng-content>
</div>
@if (isExpandable) {
  <div class="expandable-card-btn-wrapper">
    <div class="btn btn-secondary" (click)="setCardWrapperState()">
      @if (showAll) {
        <span>{{ 'LESS' | translate }}</span>
      }
      @if (!showAll) {
        <span>{{ 'MORE' | translate }}</span>
      }
    </div>
  </div>
}
